import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  Outlet,
} from "react-router-dom";

import Login from "./component/login/login";
import Register from "./component/login/Register";
import ExpressRegister from "./component/login/ExpressRegister";
import ClientStatus from "./component/admin/tools/clientStatus";
import CreateNewClient from "./component/admin/tools/createNewClient";
import Catlog from "./component/Catlog/Catlog";
import Layout from "./component/main/layout";
import CatlogList from "./component/Catlog/CatlogList";
import Dashboard from "./component/dashboard/Dashboard";
import UpdateInventoryImport from "./component/dashboard/UpdateInventoryImport";
import Allproducts from "./component/All Products/Allproducts";
import SharedProduct from "./component/Catlog/SharedProduct";
import Appointment from "./component/dashboard/Appointment";
import ProductDetails from "./component/All Products/ProductDetails";
import Administrationtools from "./component/admin/tools/administrationtools";
import ApplicationPermissions from "./component/admin/tools/ApplicationPermissions";
import DiamondRapNetPermission from "./component/admin/tools/DiamondRapNetPermission";
import AddNewRetailerToCore from "./component/admin/tools/AddNewRetailerToCore";
import VendorRatings from "./component/admin/tools/VendorRatings";
import ClientDataMapping from "./component/admin/tools/ClientDataMapping";
import Limits from "./component/admin/tools/Limits";
import Legacy from "./component/admin/tools/Legacy";
import ReportsPermissions from "./component/admin/tools/ReportsPermissions";
import Retailerlocator from "./component/admin/tools/Retailerlocator";
import BlockDesignersRetailer from "./component/admin/tools/BlockDesignersRetailer";
import LockedUsers from "./component/admin/tools/LockedUsers";
import DataMaps from "./component/admin/settings/DataMaps";
import MetalMarket from "./component/admin/settings/MetalMarket";
import LoginPreferences from "./component/admin/tools/LoginPreferences";
import Permissions from "./component/admin/settings/Permissions";
import EmailTemplate from "./component/admin/settings/EmailTemplate";
import MagentoMapping from "./component/admin/tools/MagentoMapping";
import ConsoleUpload from "./component/admin/tools/ConsoleUpload";
import HasValidImage from "./component/admin/tools/HasValidImage";
import TransferZZGemfind from "./component/admin/tools/TransferZZGemfind";
import TradeShows from "./component/admin/settings/TradeShows";
import MailingLists from "./component/admin/campaigns/MailingLists";
import CampaignData from "./component/admin/campaigns/CampaignData";
import ComposeMail from "./component/admin/campaigns/ComposeMail";
import ApiAccessToken from "./component/admin/settings/ApiAccessToken";
import Addcolor from "./component/admin/settings/Addcolor";
import PartnerAppGuard from "./component/Apps/PartnerAppGuard";
import AppPermissionGuard from "./component/Apps/AppPermissionGuard";
import PartnerTypes from "./component/admin/settings/PartnerTypes";
import UploadHistory from "./component/Catlog/UploadHistory";
import DiamondUploadHistory from "./component/Catlog/Diamonds/DiamondUploadHistory";
import UploadDiamondFile from "./component/Catlog/Diamonds/UploadDiamondFile";
import UploadProductFile from "./component/Catlog/UploadProductFile";
import ManageCollection from "./component/Catlog/ManageCollection";
import AddSignleDiamond from "./component/Catlog/Diamonds/AddSingleDiamond";
import DiamondMapping from "./component/Catlog/Diamonds/DiamondMapping";
import ProductMarkup from "./component/Catlog/ProductMarkup";
import AddCollection from "./component/Catlog/AddCollection";
import ViewMyMinedDiamond from "./component/Catlog/Diamonds/ViewMyMinedDiamond";
import ViewMyColorDiamond from "./component/Catlog/Diamonds/ViewMyColorDiamond";
import ViewMyLabDiamond from "./component/Catlog/Diamonds/ViewMyLabDiamond";
import JewelrySearch from "./component/SearchFeature/JewelrySearch";
import WatchesSearch from "./component/SearchFeature/WatchesSearch";
import SolrCoreIndexer from "./component/admin/tools/SolrCoreIndexer";
import DiamondSearch from "./component/SearchFeature/DiamondSearch";
import ColorDiamondSearch from "./component/SearchFeature/ColorDiamondSearch";
import LabDiamondSearch from "./component/SearchFeature/LabDiamondSearch";
import { NotificationContainer } from "react-notifications";
import { useSelector, useDispatch } from "react-redux";
import FTPCredential from "./component/Catlog/Diamonds/FTPCredential";
import FancyColorMarkup from "./component/Apps/DiamondLinks/FancyColorMarkup";
import LabGrowMarkup from "./component/Apps/DiamondLinks/LabGrowMarkup";
import Options from "./component/Apps/DiamondLinks/Options";
import DiamondLinksEmailTemplate from "./component/Apps/DiamondLinks/DiamondLinksEmailTemplate";
import ApplicationPreview from "./component/Apps/DiamondLinks/ApplicationPreview";
import Shipping from "./component/Apps/DiamondLinks/Shipping";
import Navigation from "./component/Apps/DiamondLinks/Navigation";
import DiamondLinkLegacy from "./component/Apps/DiamondLinks/DiamondLinkLegacy";
import ShoppingIntegrations from "./component/Apps/DiamondLinks/ShoppingIntegrations";
import Dealers from "./component/Apps/DiamondLinks/Dealers";
import MinedDiamondsMarkup from "./component/Apps/DiamondLinks/MinedDiamondMarkup";
import Markups from "./component/Apps/RingBuilder/Markups";
import Settings from "./component/Apps/RingBuilder/Settings";
import RingbuilderNavigation from "./component/Apps/RingBuilder/RingbuilderNavigation";
import RingbuilderLegacy from "./component/Apps/RingBuilder/RingbuilderLegacy";
import RingbuilderShoppingIntegrations from "./component/Apps/RingBuilder/RingbuilderShoppingIntegrations";
import AvailableFilterSettings from "./component/Apps/DiamondLinks/AvailableFilterSettings";
import InitialFilterSettings from "./component/Apps/DiamondLinks/InitialFilterSettings";
import RingBuilderOptions from "./component/Apps/RingBuilder/Options";
import RingBuilderEmailTemplate from "./component/Apps/RingBuilder/EmailTemplate";
import RingBuilderDealers from "./component/Apps/RingBuilder/RingBuilderDealers";
import Vendors from "./component/Apps/RingBuilder/Vendors";
import MyNetworkStudBuilder from "./component/Apps/StudBuilder/MyNetworkStudBuilder";
import MyNetworkPendantBuilder from "./component/Apps/PendantBuilder/MyNetworkPendantBuilder";
import StudBuilderManageVendors from "./component/Apps/StudBuilder/StudBuilderManageVendors";
import ArchiveVendors from "./component/Apps/RingBuilder/ArchiveVendors";
import RingBuilderDaimondMarkup from "./component/Apps/RingBuilder/RingBuilderDaimondMarkup";
import RingBuilderLabGrowMarkup from "./component/Apps/RingBuilder/RingBuilderLabGrowMarkup";
import MasterLinkLegacy from "./component/Apps/MasterLink/MasterLinkLegacy";
import OutGoingDataMap from "./component/admin/tools/OutGoingDataMap";
import OutBoundSync from "./component/admin/tools/OutBoundSync";
import PendingSync from "./component/admin/tools/PendingSync";
import StudBuilderApplicationPreview from "./component/Apps/StudBuilder/StudBuilderApplicationPreview";
import StudBuilderEmailTemplate from "./component/Apps/StudBuilder/StudBuilderEmailTemplate";
import MasterLinkOptions from "./component/Apps/MasterLink/MasterLinkOptions";
import MasterLinkShipping from "./component/Apps/MasterLink/MasterLinkShipping";
import MasterLinkEmailTemplate from "./component/Apps/MasterLink/MasterLinkEmailTemplate";
import MasterLinkShoppingIntegration from "./component/Apps/MasterLink/MasterLinkShoppingIntegration";
import PendantBuilderApplicationPreview from "./component/Apps/PendantBuilder/PendantBuilderApplicationPreview";
import StudBuilderOptions from "./component/Apps/StudBuilder/StudBuilderOptions";
import StudBuilderSettings from "./component/Apps/StudBuilder/StudBuilderSettings";
import StudBuilderShoppingIntegrations from "./component/Apps/StudBuilder/StudBuilderShoppingIntegrations";
import WatchCustomizer from "./component/Apps/WatchCustomizer/WatchCustomizer";
import PendantBuilderOptions from "./component/Apps/PendantBuilder/PendantBuilderOptions";
import PendantBuilderSettings from "./component/Apps/PendantBuilder/PendantBuilderSettings";
import PendantBuilderEmailTemplate from "./component/Apps/PendantBuilder/PendantBuilderEmailTemplate";
import PendantBuilderShoppingIntegrations from "./component/Apps/PendantBuilder/PendantBuilderShoppingIntegrations";
import PendantBuilderNavigation from "./component/Apps/PendantBuilder/PendantBuilderNavigation";
import StudBuilderNavigation from "./component/Apps/StudBuilder/StudBuilderNavigation";
import PedantBuilderDealers from "./component/Apps/PendantBuilder/PedantBuilderDealers";
import Timepieces from "./component/Apps/Timepieces";
import MyVendors from "./component/Community/VendorManager/MyVendors";
import Network from "./component/Community/VendorManager/Network";
import Inviteyourvendor from "./component/Community/VendorManager/Inviteyourvendor";
import New from "./component/Community/VendorManager/New";
import OutOfNetwork from "./component/Community/VendorManager/OutOfNetwork";
import RecentlyUpdated from "./component/Community/VendorManager/RecentlyUpdated";
import VendorManagerPopular from "./component/Community/VendorManager/VendorManagerPopular";
import VendorManagerArchived from "./component/Community/VendorManager/VendorManagerArchived";
import RetailerProfile from "./component/Retailer/RetailerProfile";
import JewelryRetailerPermission from "./component/Retailer/JewelryRetailerPermission";
import PendingJewelryRequest from "./component/Retailer/PendingJewelryRequest";
import DiamondRetailerPermission from "./component/Retailer/DiamondRetailerPermission";
import PendingDiamondRequest from "./component/Retailer/PendingDiamondRequest";
import GemstoneRetailerPermission from "./component/Retailer/GemstoneRetailerPermission";
import RingBuilderRetailerPermission from "./component/Retailer/RingBuilderRetailerPermission";
import PendingRingBuilderRequest from "./component/Retailer/PendingRingBuilderRequest";
// import VendorManagerPopular from "./component/Community/VendorManager/VendorManagerPopular";
// import VendorManagerArchived from "./component/Community/VendorManager/VendorManagerArchived";
import PurchaseOrder from "./component/Purchase Order/PurchaseOrder";
import PurchaseOrderHistory from "./component/Purchase Order/PurchaseOrderHistory";
import UpdatePurchaseOrder from "./component/Purchase Order/UpdatePurchaseOrder";
import VendorManagerPendingRequests from "./component/Community/VendorManager/VendorManagerPendingRequests";
import UploadMarketingMaterial from "./component/Marketing/UploadMarketingMaterial";
import AddProducts from "./component/Catlog/AddProducts";
import CompanyProfile from "./component/User Profile/companyProfile";
import UserSettings from "./component/User Profile/UserSettings";
import SocialIntegrations from "./component/User Profile/SocialIntegrations";
import UserProfile from "./component/User Profile/userProfile";
import JewelryCategoryReport from "./component/reports/jewelry/JewelryCategoryReport";
import JewelryChartReport from "./component/reports/jewelry/JeweleryChartReports";
import DataMaping from "./component/Catlog/DataMapping/DataMaping";
import ManageUser from "./component/User Profile/ManageUser";
import ManageAccount from "./component/User Profile/ManageAccount";
import ManageLanguage from "./component/User Profile/ManageLanguage";
import ManageCurrency from "./component/User Profile/ManageCurrency";

import RingBuilderApiEndPoint from "./component/Apps/RingBuilder/RingBuilderApiEndPoint";
import DiamondLinkApiEndPoint from "./component/Apps/DiamondLinks/DiamondLinkApiEndPoint";
import JewelryChartReportAdmin from "./component/admin/JewelryReport/JewelryChartReportAdmin";
import JewelryCategoryReportAdmin from "./component/admin/JewelryReport/JewelryCategoryReportAdmin";
import JewelryMetalTypeReport from "./component/admin/JewelryReport/JewelryMetalTypeReport";
import JewelryPriceReport from "./component/admin/JewelryReport/JewelryPriceReport";
import JewelryRetailerClicksReport from "./component/admin/JewelryReport/JewelryRetailerClicksReport";
import JewelryVendorClicksReport from "./component/admin/JewelryReport/JewelryVendorClicksReport";
import Syncs from "./component/admin/reports/Syncs";
import ToolsReports from "./component/admin/reports/ToolsReports";
import DataRelated from "./component/admin/reports/DataRelated";
import JewelryLogReports from "./component/admin/reports/JewelryLogReports";
import GlobalEvents from "./component/admin/reports/GlobalEvents";
import ClientsReports from "./component/admin/reports/ClientsReports";
import StudBuilderMarkup from "./component/Apps/StudBuilder/StudBuilderMarkup";
import StudBuilderDealers from "./component/Apps/StudBuilder/StudBuilderDealers";
import StudBuilderDaimondMarkup from "./component/Apps/StudBuilder/StudBuilderDaimondMarkup";
import PendantBuilderManageVendors from "./component/Apps/PendantBuilder/PendantBuilderManageVendor";
import PendantBuilderSettingMarkup from "./component/Apps/PendantBuilder/PendantBuilderSettingMarkup";
import PendantBuilderDiamondMarkup from "./component/Apps/PendantBuilder/PendantBuilderDiamondMarkup";
import StudbuilderLabGrowMarkup from "./component/Apps/StudBuilder/StudbuilderLabGrowMarkup";
import PendantBuilderLabGrowMarkup from "./component/Apps/PendantBuilder/PendantBuilderLabGrowMarkup";
import DiamondClicks from "./component/admin/DiamondReport/DiamondClicks";
import ExtendedDiamondChartReports from "./component/admin/DiamondReport/ExtendedDiamondChartReports";
import DiamondClarityReport from "./component/admin/DiamondReport/DiamondClarityReport";
import DiamondColor from "./component/admin/DiamondReport/DiamondColor";
import SyncHistory from "./component/Apps/WebsiteSync/SyncHistory";
import OutBoundMapping from "./component/Apps/WebsiteSync/OutBoundMapping";
import FtpDetails from "./component/Apps/WebsiteSync/FtpDetails";
import DiamondCutReport from "./component/admin/DiamondReport/DiamondCutReport";
import DiamondShapeReport from "./component/admin/DiamondReport/DiamondShapeReport";
import DiamondCertificateReport from "./component/admin/DiamondReport/DiamondCertificateReport";
import DiamondSizeReport from "./component/admin/DiamondReport/DiamondSizeReport";
import GemstoneClicks from "./component/admin/GemstoneReport/GemstoneClicks";
import ExtendedGemstoneChartReports from "./component/admin/GemstoneReport/ExtendedGemstoneChartReports";
import GemstoneClarityReport from "./component/admin/GemstoneReport/GemstoneClarityReport";
import GemstoneGemTypeReport from "./component/admin/GemstoneReport/GemstoneGemTypeReport";
import GemstoneColor from "./component/admin/GemstoneReport/GemstoneColor";
import GemstoneCutReport from "./component/admin/GemstoneReport/GemstoneCutReport";
import GemstoneShapeReport from "./component/admin/GemstoneReport/GemstoneShapeReport";
import GemstoneCertificateReport from "./component/admin/GemstoneReport/GemstoneCertificateReport";
import GemstoneSizeReport from "./component/admin/GemstoneReport/GemstoneSizeReport";
// import { PendingSync } from "./component/admin/tools/PendingSync";

import i18n from "./i18n";
import RequestAppointment from "./component/login/RequestAppointment";
import JewelryMetalTypeReportMain from "./component/reports/jewelry/JewelryMetalTypeReportMain";
import AddToCartReports from "./component/reports/jewelry/AddToCartReports";
import WishListReports from "./component/reports/jewelry/WishListReports";
import JewelryPriceReportMain from "./component/reports/jewelry/JewelryPriceReportMain";
import JewelryRetailerClickReportMain from "./component/reports/jewelry/JewelryRetailerClickReportMain";
import JewelryVendorClickReportMain from "./component/reports/jewelry/JewelryVendorClickReportMain";
import JewelryLocationActivity from "./component/reports/jewelry/JewelryLocationActivity";
import GlobalJewelryChartReports from "./component/reports/GlobalJewelry/GlobalJewelryChartReports";

import ExtendedDiamondChartReportsMain from "./component/reports/Diamonds/ExtendedDiamondChartReportsMain";
/*Reports Diamond Individual Pages Start*/
import DiamondReportsShapeIndComp from "./component/ChartsGroup/DiamondReportsCharts/DiamondReportsShapeIndComp";
import DiamondReportsClarityIndComp from "./component/ChartsGroup/DiamondReportsCharts/DiamondReportsClarityIndComp";
import DiamondReportsCertificateIndComp from "./component/ChartsGroup/DiamondReportsCharts/DiamondReportsCertificateIndComp";
import DiamondReportsCutIndComp from "./component/ChartsGroup/DiamondReportsCharts/DiamondReportsCutIndComp";
import DiamondReportsColorIndComp from "./component/ChartsGroup/DiamondReportsCharts/DiamondReportsColorIndComp";
import DiamondReportsSizeIndComp from "./component/ChartsGroup/DiamondReportsCharts/DiamondReportsSizeIndComp";
import DiamondReportsChartsIndComp from "./component/ChartsGroup/DiamondReportsCharts/DiamondReportsChartsIndComp";
import DiamondReportsClicksIndComp from "./component/ChartsGroup/DiamondReportsCharts/DiamondReportsClicksIndComp";

/*Reports Diamond Individual Pages End*/
import LocationActivity from "./component/reports/Diamonds/LocationActivity";
import GlobalExtendedDiamondChartReports from "./component/reports/GlobalDiamonds/GlobalExtendedDiamondChartReports";
import GlobalDiamondClarityReport from "./component/reports/GlobalDiamonds/GlobalDiamondClarityReport";
/*Global Diamond Individual Pages Start*/
import DiamondClarityIndComp from "./component/ChartsGroup/DiamondClarityIndComp";
import DiamondColorIndComp from "./component/ChartsGroup/DiamondColorIndComp";
import DiamondCutIndComp from "./component/ChartsGroup/DiamondCutIndComp";
import DiamondCertificateIndComp from "./component/ChartsGroup/DiamondCertificateIndComp";
import DiamondSizeIndComp from "./component/ChartsGroup/DiamondSizeIndComp";
import DiamondShapeIndComp from "./component/ChartsGroup/DiamondShapeIndComp";
/*Global Diamond Individual Pages End*/

import ExtendedGemstoneChartReportsMain from "./component/reports/Gemstones/ExtendedGemstoneChartReportsMain";
/*Reports Gemstone Individual Pages Start*/
import GemstoneReportsShapeIndComp from "./component/ChartsGroup/GemstoneReportsCharts/GemstoneReportsShapeIndComp";
import GemstoneReportsClarityIndComp from "./component/ChartsGroup/GemstoneReportsCharts/GemstoneReportsClarityIndComp";
import GemstoneReportsGemTypeIndComp from "./component/ChartsGroup/GemstoneReportsCharts/GemstoneReportsGemTypeIndComp";
import GemstoneReportsCertificateIndComp from "./component/ChartsGroup/GemstoneReportsCharts/GemstoneReportsCertificateIndComp";
import GemstoneReportsCutIndComp from "./component/ChartsGroup/GemstoneReportsCharts/GemstoneReportsCutIndComp";
import GemstoneReportsColorIndComp from "./component/ChartsGroup/GemstoneReportsCharts/GemstoneReportsColorIndComp";
import GemstoneReportsSizeIndComp from "./component/ChartsGroup/GemstoneReportsCharts/GemstoneReportsSizeIndComp";
import GemstoneReportsChartsIndComp from "./component/ChartsGroup/GemstoneReportsCharts/GemstoneReportsChartsIndComp";
import GemstoneReportsClicksIndComp from "./component/ChartsGroup/GemstoneReportsCharts/GemstoneReportsClicksIndComp";
/*Reports Gemstone Individual Pages End*/
import GemstoneLocationActivity from "./component/reports/Gemstones/LocationActivity";
import GlobalExtendedGemstoneChartReports from "./component/reports/GlobalGemstones/GlobalExtendedGemstoneChartReports";
/*Global Gemstone Individual Pages Start*/
import GemstoneClarityIndComp from "./component/ChartsGroup/GemstoneClarityIndComp";
import GemstoneGemTypeIndComp from "./component/ChartsGroup/GemstoneGemTypeIndComp";
import GemstoneColorIndComp from "./component/ChartsGroup/GemstoneColorIndComp";
import GemstoneCutIndComp from "./component/ChartsGroup/GemstoneCutIndComp";
import GemstoneCertificateIndComp from "./component/ChartsGroup/GemstoneCertificateIndComp";
import GemstoneSizeIndComp from "./component/ChartsGroup/GemstoneSizeIndComp";
import GemstoneShapeIndComp from "./component/ChartsGroup/GemstoneShapeIndComp";
import GemstoneChartsIndComp from "./component/ChartsGroup/GemstoneChartsIndComp";
/*Global Gemstone Individual Pages End*/
import GlobalJewelryCategoryReport from "./component/reports/GlobalJewelry/GlobalJewelryCategoryReport";
import GlobalJewelryMetalTypeReport from "./component/reports/GlobalJewelry/GlobalJewelryMetalTypeReport";
import WatchCustomizerOptions from "./component/Apps/WatchCustomizer/WatchCustomizerOptions";
import Conversation from "./component/contacts/conversation";
import Customer from "./component/contacts/customer";
import ProfileNew from "./component/contacts/profile";
import Contact from "./component/contacts/Contact";
import Appointments from "./component/contacts/Appointments";
import ResetPassword from "./component/login/ResetPassword";
import EditViewDataMapping from "./component/Catlog/Diamonds/EditViewDataMapping";
import MakeAppoitments from "./component/Retailer/MakeAppoitments";
import ViewInquiry from "./component/Apps/DiamondLinks/ViewInquiry";
import VendorProfile from "./component/Community/VendorManager/VendorProfile";
import DealerProfile from "./component/Apps/Dealer/DealerProfile";
import InboundClientDataMaping from "./component/InboundClientDataMaping/InboundClientDataMaping";
import CompanyLocation from "./component/User Profile/CompanyLocation";
import AllApps from "./component/Apps/AllApps";
import GlobalJewelryPriceReport from "./component/reports/GlobalJewelry/GlobalJewelryPriceReport";
import DiamondAddToCartReport from "./component/reports/Diamonds/DiamondAddToCartReport";
import DiamondWishListReport from "./component/reports/Diamonds/DiamondWishListReport";
import GlobalGemstoneAddToCartReport from "./component/reports/GlobalGemstones/GlobalGemstoneAddToCartReport";
import GlobalGemstoneWishListReport from "./component/reports/GlobalGemstones/GlobalGemstoneWishListReport";
import GemstoneAddToCartReport from "./component/reports/Gemstones/GemstoneAddToCartReport";
import GemstoneWishListReport from "./component/reports/Gemstones/GemstoneWishListReport";
import JewerlyWishListReport from "./component/reports/jewelry/JewerlyWishListReport";
import VendorActivityReport from "./component/reports/VendorActivityReport";
import TermsOfService from "./component/login/TermsOfService";
import PrivacyStatement from "./component/login/PrivacyStatement";
import UploadAdminProductFile from "./component/admin/tools/UploadProductFile";
import ChangePassword from "./component/User Profile/ChangePassword";
import InviteARetailer from "./component/Retailer/InviteARetailer";
import PageNotAccess from "./component/PageNotAccess";
import ReportPermissionGuard from "./component/common/ReportPermissionGuard";
import FeatureGuard from "./component/common/FeatureGuard";
import DiamondVendors from "./component/Apps/RingBuilder/DiamondVendor";
import AllProduct from "./component/Catlog/Allproduct";
import Print from "./component/Catlog/Print";
import BlockedProduct from "./component/dashboard/BlockedProduct";
import AddCampaignPage from "./component/admin/campaigns/AddCampaignPage";
import MyVendorsRingBuilder from "./component/Apps/RingBuilder/MyVendorsRingBuilder";
import MyVendorsStudBuilder from "./component/Apps/StudBuilder/MyVendorsStudBuilder";
import MyVendorsPendantBuilder from "./component/Apps/PendantBuilder/MyVendorsPendantBuilder";
import RingBuilderPendingVendorRequest from "./component/Apps/RingBuilder/RingBuilderPendingVendorRequest";
import PendantBuilderPendingVendorRequest from "./component/Apps/PendantBuilder/PendantBuilderPendingVendorRequest";
import StudBuilderPendingVendorRequest from "./component/Apps/StudBuilder/StudBuilderPendingVendorRequest";
import RetailerGroup from "./component/Catlog/RetailerGroup";
import DiamondGroupDiscount from "./component/Catlog/DiamondGroupDiscount";
import PurchaseOrderDetails from "./component/Purchase Order/PurchaseOrderDetails";
import VendorRequest from "./component/Community/VendorManager/VendorRequest";
import Marketing from "./component/admin/settings/Marketing";
import RetailerMarketing from "./component/admin/settings/RetailerMarketing";
import MarketingUploadFile from "./component/admin/settings/MarketingUploadFile";
import MarketingUploadVendor from "./component/admin/settings/MarketingUploadVendor";
import RetailerProfileNew from "./component/Retailer/RetailerProfileNew";
import SyncLimiter from "./component/Catlog/SyncLimiter";
import PODashboard from "./component/Purchase Order/PODashboard";
import VendorOrderBuilder from "./component/Purchase Order/VendorOrderBuilder";
import MyOrders from "./component/Purchase Order/MyOrders";
import OrderReport from "./component/Purchase Order/OrderReport";
import OrganizerDashboard from "./component/Purchase Order/OrganizerDashboard";
import DeliverySettings from "./component/Purchase Order/DeliverySettings";
import Inbox from "./component/Purchase Order/Inbox";
import OrderLog from "./component/Purchase Order/OrderLog";
import OrderDetail from "./component/Purchase Order/OrderDetail";
import Worksheet from "./component/Purchase Order/Worksheet";
import WorkSheetDetails from "./component/Purchase Order/WorkSheetDetails";
import Addresses from "./component/Purchase Order/Addresses";
import Basket from "./component/Purchase Order/Basket";
import DocumentDetail from "./component/DiamondTrade/DocumentDetail";
import MyMemos from "./component/DiamondTrade/MyMemos";
import DiamondPurchaseOrders from "./component/DiamondTrade/DiamondPurchaseOrders";
import SupplierRequests from "./component/DiamondTrade/SupplierRequests";
import ReturnsInbound from "./component/DiamondTrade/ReturnsInbound";
import SupplierDashboard from "./component/DiamondTrade/SupplierDashboard";
import DiamondReports from "./component/DiamondTrade/DiamondReports";
import ManageCompanyShows from "./component/User Profile/ManageCompanyShows";
import ManageBrands from "./component/User Profile/ManageBrands";
import ApplicationPreviewRing from "./component/Apps/RingBuilder/ApplicationPreviewRing";
import ApplicationPreviewStud from "./component/Apps/StudBuilder/ApplicationPreviewStudBuilder";
import ApplicationPreviewPedant from "./component/Apps/PendantBuilder/ApplicationPreviewPedant";
import ManageInventory from "./component/Community/VendorManager/ManageInventory";
import ApplicationPreviewMasterlink from "./component/Apps/MasterLink/ApplicationPreviewMasterlink";
import DepartmentsMasterLink from "./component/Apps/MasterLink/DepartmentsMasterLink";
import ViewInventory from "./component/Community/VendorManager/ViewInventory";
import PricingGeneral from "./component/Catlog/Pricing/General";
import CreateDiscardCollection from "./component/Catlog/CreateDiscardCollection";
import Brands from "./component/Catlog/Brands/Brands";
import Vendor from "./component/Catlog/Vendor/Vendor";
// import CompanyEmailSetting from "./component/User Profile/CompanyEmailSetting";
import InviteYourRetailer from "./component/Retailer/InviteYourRetailer";
import SuggestFeature from "./component/Help/SuggestFeature";
import StuckFile from "./component/Catlog/StuckFile";
import StuckFileJewelry from "./component/Catlog/Diamonds/StuckFileJewelry";
import JeweleryPriceBasedAddToCartReports from "./component/reports/jewelry/JeweleryPriceBasedAddToCartReports";
import JeweleryPriceBasedWishListReports from "./component/reports/jewelry/JeweleryPriceBasedWishListReports";
import DiamondPriceBasedAddToCartReports from "./component/reports/Diamonds/DiamondPriceBasedAddToCartReports";
import DiamondPriceBasedWishListReports from "./component/reports/Diamonds/DiamondPriceBasedWishListReports";
import GemstonePriceBasedAddToCartReports from "./component/reports/Gemstones/GemstonePriceBasedAddToCartReports";
import GemstoneVendorBasedAddToCartReport from "./component/reports/Gemstones/GemstoneVendorBasedAddToCart";
import GemstoneVendorBasedWishListReport from "./component/reports/Gemstones/GemstoneVendorBasedWishListReports";
import GemstonePriceBasedWishListReports from "./component/reports/Gemstones/GemstonePriceBasedWishListReports";
import WhiteLabel from "./component/White Label/WhiteLabel";
import Organization from "./component/White Label/Organization";
import sessionManager from "./utils/simpleSessionManager";
import { useCookies } from "react-cookie";
import SCAMaster from "./component/White Label/SCAMaster";
import MinedDiamondMarkup from "./component/Apps/DiamondLinks/MinedDiamondMarkup";
import { setNewLoginData } from "./actions/login/login";
import {
  setChecklinkHeaderMenuData,
  setImpersonateHeaderMenuData,
  setOpenKeyHeaderMenuData,
  setSelectSideMenu,
} from "./actions/headerMenu/headerMenu";
import { store } from "./redux/store";
import TrackingHandler from "./component/Tracking/TrackingHandler";
import ColorStoneSearch from "./component/SearchFeature/ColorStoneSearch";
import ViewMyColorStone from "./component/Catlog/ColorStones/ViewMyColorStone";
import UploadColorStoneFile from "./component/Catlog/ColorStones/UploadColorStoneFile";
import ColorStoneUploadHistory from "./component/Catlog/ColorStones/ColorStoneUploadHistory";
import AddSingleColorStone from "./component/Catlog/ColorStones/AddSingleColorStone";
import ColorStoneMapping from "./component/Catlog/ColorStones/ColorStoneMapping";
import ColorStoneFtpCredentials from "./component/Catlog/ColorStones/FTPCredential";
import GemStoneMarkup from "./component/Apps/GemStoneLinks/GemStoneMarkup";
import { GemStoneOptions } from "./component/Apps/GemStoneLinks/Options";
import { identifyImpersonatedUser } from "./analytics/identity";
import { track } from "./analytics/track";
import { EVENTS } from "./analytics/events";
import ManageGemStoneVendor from "./component/Apps/GemStoneLinks/Dealers";
import ApplicationPreviewGemStone from "./component/Apps/GemStoneLinks/ApplicationPreviewGemStone";
import GemStoneLinksEmailTemplate from "./component/Apps/GemStoneLinks/GemStoneLinksEmailTemplate";



const PrivateRoute = () => {
  const loginDetials = useSelector((state) => state.loginReducer);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 1000); // wait 1s
    return () => clearTimeout(timer);
  }, []);

  if (!ready) {
    return <div>Loading...</div>; // you can replace with spinner
  }

  let logInSucceeded = false;

  if (loginDetials.loginDetials?.responseData?.logInSucceeded) {
    logInSucceeded = true;
  } else if (loginDetials.payload?.responseData?.logInSucceeded) {
    logInSucceeded = true;
  }

  return logInSucceeded ? (
    <Layout>
      <Outlet />
    </Layout>
  ) : (
    <Navigate to="/" />
  );
};

export const App = () => {
  const language = useSelector((state) => state.headerMenuReducer.language);
  const [rehydrated, setRehydrated] = useState(false);
  const [handoffChecked, setHandoffChecked] = useState(false);
  const dispatch = useDispatch();

  // Initialize session management on app start
  useEffect(() => {
    const initializeSession = () => {
      try {
        // Check for existing session
        const currentSession = sessionManager.getCurrentSession();
        const sessionType = sessionManager.getSessionType();

        console.log("Session initialization:", {
          sessionType,
          hasSession: !!currentSession,
        });

        if (currentSession && currentSession.loginData) {
          // Restore session data to Redux
          dispatch(setNewLoginData({ responseData: currentSession.loginData }));

          if (currentSession.headerMenuData) {
            if (sessionType === "impersonation") {
              dispatch(
                setImpersonateHeaderMenuData(currentSession.headerMenuData)
              );
            }
            // Only restore navigation state if not already set by Redux persist
            // This prevents overriding the correct state that was already restored
            setTimeout(() => {
              const currentState = store.getState();
              const headerState = currentState.headerMenuReducer;

              // Only restore from session if current state is empty or default
              if (!headerState.checkLink || headerState.checkLink === "") {
                if (currentSession.headerMenuData.checkLink) {
                  dispatch(
                    setChecklinkHeaderMenuData(
                      currentSession.headerMenuData.checkLink
                    )
                  );
                }
                if (currentSession.headerMenuData.openKey) {
                  dispatch(
                    setOpenKeyHeaderMenuData(
                      currentSession.headerMenuData.openKey
                    )
                  );
                }
                if (currentSession.headerMenuData.selectSideMenu) {
                  dispatch(
                    setSelectSideMenu(
                      currentSession.headerMenuData.selectSideMenu
                    )
                  );
                }
              }
            }, 100); // Small delay to ensure Redux persist has completed
          }
        } else {
          // If no session found, this might be a fresh login tab
          // Check if there's Redux data that needs to be saved to session
          console.log(
            "No existing session found, checking for fresh login state"
          );
        }

        setRehydrated(true);
      } catch (error) {
        console.error("Session initialization failed:", error);
        setRehydrated(true);
      }
    };

    initializeSession();
  }, [dispatch]);

  // Handle impersonation handoff from admin tools
  useEffect(() => {
    if (!rehydrated) return;

    const origin = window.location.origin;
    const onMessage = (event) => {
      if (event.origin !== origin) return;

      if (event.data && event.data.type === "PING") {
        event.source && event.source.postMessage("PONG", origin);
        return;
      }

      if (event.data && event.data.impersonateDealerId) {
        // Handle impersonation message
        console.log("Received impersonation message:", event.data);
      }
    };

    window.addEventListener("message", onMessage);

    // Check for impersonation handoff on first load
    const checkHandoff = () => {
      try {
        const handoffRaw = window.localStorage.getItem("IMPERSONATE_HANDOFF");
        if (handoffRaw) {
          const handoff = JSON.parse(handoffRaw);
          console.log("Processing impersonation handoff:", handoff);

          // Initialize impersonation session using session manager
          const success = sessionManager.initializeImpersonationSession({
            loginData: handoff.loginData,
            headerMenuData: handoff.headerMenuData,
            dealerId: handoff.dealerId,
            impersonationTime: handoff.impersonationTime,
          });

          if (success) {
            // Update Redux with impersonation data
            dispatch(setNewLoginData({ responseData: handoff.loginData }));
            dispatch(setImpersonateHeaderMenuData(handoff.headerMenuData));

            // handoff.sessionRef is populated once task #1745 (administrationtools.js)
            // adds it to the IMPERSONATE_HANDOFF payload; undefined until then.
            identifyImpersonatedUser(
              handoff,
              sessionManager.getAdminSession(),
              handoff.sessionRef
            );

            const impersonationStartedAt = Date.now();
            const onImpersonationTabClose = () => {
              track(EVENTS.IMPERSONATION_ENDED, {
                end_reason: "tab_closed",
                duration_seconds: Math.round(
                  (Date.now() - impersonationStartedAt) / 1000
                ),
                session_ref: handoff.sessionRef,
              });
            };
            window.addEventListener("beforeunload", onImpersonationTabClose);

            // Restore navigation state from handoff data
            setTimeout(() => {
              if (handoff.headerMenuData.checkLink) {
                dispatch(
                  setChecklinkHeaderMenuData(handoff.headerMenuData.checkLink)
                );
              }
              if (handoff.headerMenuData.openKey) {
                dispatch(
                  setOpenKeyHeaderMenuData(handoff.headerMenuData.openKey)
                );
              }
              if (handoff.headerMenuData.selectSideMenu) {
                dispatch(
                  setSelectSideMenu(handoff.headerMenuData.selectSideMenu)
                );
              }
            }, 100);

            console.log("Impersonation session initialized successfully");

            // Clear handoff data
            window.localStorage.removeItem("IMPERSONATE_HANDOFF");
          } else {
            console.error("Failed to initialize impersonation session");
          }
        }
      } catch (e) {
        console.error("Error processing handoff:", e);
      } finally {
        setHandoffChecked(true);
      }
    };

    if (!handoffChecked) {
      checkHandoff();
    }

    return () => {
      window.removeEventListener("message", onMessage);
    };
  }, [dispatch, rehydrated, handoffChecked]);

  // Additional UI event handlers
  useEffect(() => {
    const handleCloseDropdowns = (e) => {
      if (
        e.target.closest(".ant-select-dropdown") ||
        e.target.closest(".ant-picker-dropdown")
      ) {
        return;
      }

      const openSelects = document.querySelectorAll(
        ".ant-select.ant-select-open"
      );
      openSelects.forEach((dropdown) => {
        const selectInput = dropdown.querySelector("input");
        if (selectInput) {
          selectInput.blur();
        }
      });

      const openDatePickers = document.querySelectorAll(
        ".ant-picker.ant-picker-focused"
      );
      openDatePickers.forEach((datePicker) => {
        const inputElement = datePicker.querySelector("input");
        if (inputElement) {
          inputElement.blur();
        }
      });
    };

    window.addEventListener("scroll", handleCloseDropdowns);
    window.addEventListener("wheel", handleCloseDropdowns);

    return () => {
      window.removeEventListener("scroll", handleCloseDropdowns);
      window.removeEventListener("wheel", handleCloseDropdowns);
    };
  }, []);

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  useEffect(() => {
    const script = document.createElement("script");
    script.id = "ze-snippet";
    script.src =
      "https://static.zdassets.com/ekr/snippet.js?key=4f1817b7-15e0-4539-b62d-202b48cd8c9c";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  const [langcookies, setLangcookies] = useCookies(["lngCookie"]);
  const expiryTime = new Date();
  expiryTime.setTime(expiryTime.getTime() + 3 * 60 * 60 * 1000); ///3 hours expiry time
  const domainSite = extractDomain();
  function extractDomain() {
    const url = window.location.href;
    const domainMatch = url.match(/:\/\/(www[0-9]?\.)?([^/:]+)/i);

    if (domainMatch && domainMatch.length > 2) {
      const fullDomain = domainMatch[2];
      const parts = fullDomain.split(".");
      if (parts.length >= 2) {
        const domain = "." + parts.slice(-2).join(".");
        return domain;
      }
    }

    return null;
  }
  setLangcookies("lngCookie", language, {
    path: "/",
    expires: new Date(Date.now() + 86400000),
    domain: domainSite,
  });

  return (
    <BrowserRouter>
      <React.Fragment>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/createNewPassword" element={<Login />} />
          <Route path="/successfullverification" element={<Login />} />
          <Route path="/customerLogin" element={<Login />} />
          <Route path="/ProductInfo" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/expressRegister" element={<ExpressRegister />} />
          <Route exact path="/CreateDiscardCollection" element={<Login />} />
          <Route path="/CompanyEmailSetting" element={<Login />} />
          <Route
            exact
            path="/DiscardCollection"
            element={<CreateDiscardCollection />}
          />

          <Route exact path="/contactAppointment" element={<Login />} />
          <Route exact path="/contactAppointment" element={<Appointment />} />

          <Route path="/requestAppointment" element={<RequestAppointment />} />
          <Route path="/resetPassword" element={<ResetPassword />} />

          <Route path="/termsOfService" element={<TermsOfService />} />
          <Route path="/privacyStatement" element={<PrivacyStatement />} />

          {/* Tracking Routes - Handle WordPress tracking URLs */}
          {/* DiamondLink Tracking */}
          <Route path="/api/DiamondLink/DiamondTracking" element={<TrackingHandler appType="diamond" />} />
          <Route path="/api/DiamondLink/ProductTracking" element={<TrackingHandler appType="diamond-product" />} />
          <Route path="/api/DiamondLink/DiamondTracking_Pair" element={<TrackingHandler appType="diamond-pair" />} />
          {/* RingBuilder Tracking */}
          <Route path="/ProductTracking" element={<TrackingHandler appType="ringbuilder-product" />} />
          <Route path="/api/RingBuilder/ActivityTracking" element={<TrackingHandler appType="ringbuilder-activity" />} />
          {/* MasterLink Tracking (DiamondLinkForML) */}
          <Route path="/api/DiamondLinkForML/DiamondTracking" element={<TrackingHandler appType="masterlink-diamond" />} />
          <Route path="/api/DiamondLinkForML/ProductTracking" element={<TrackingHandler appType="masterlink-product" />} />
          <Route path="/api/DiamondLinkForML/DiamondTracking_Pair" element={<TrackingHandler appType="masterlink-diamond-pair" />} />
          {/* MasterLink Tracking (RingBuilderForML) */}
          <Route path="/api/RingBuilderForML/ProductTracking" element={<TrackingHandler appType="masterlink-ringbuilder-product" />} />

          <Route exact path="/" element={<PrivateRoute />}>
            <Route exact path="/notAccess" element={<PageNotAccess />} />

            <Route exact path="/notAccess1" element={<PageNotAccess />} />
            <Route exact path="/notAccess2" element={<PageNotAccess />} />
            <Route exact path="/notAccess3" element={<PageNotAccess />} />
            <Route exact path="/notAccess4" element={<PageNotAccess />} />
            <Route
              exact
              path="/administrationTools"
              element={<Administrationtools />}
            />
            <Route
              exact
              path="/createNewClient"
              element={<CreateNewClient />}
            />
            <Route exact path="/clientStatus" element={<ClientStatus />} />
            <Route exact path="/catalog" element={<Catlog />} />
            <Route exact path="/catalogList" element={<CatlogList />} />
            <Route exact path="/dashboard" element={<Dashboard />} />
            <Route exact path="/blockedProduct" element={<BlockedProduct />} />
            <Route
              exact
              path="/updateInventoryImport"
              element={<UpdateInventoryImport />}
            />
            <Route
              exact
              path="/createNewPasswordMasterlink"
              element={<ApplicationPreviewMasterlink />}
            />
            <Route
              exact
              path="/MasterLinkApplicationPreview"
              element={
                <PartnerAppGuard>
                  <ApplicationPreviewMasterlink />
                </PartnerAppGuard>
              }
            />
            <Route
              exact
              path="/viewCatalog"
              element={<ApplicationPreviewMasterlink />}
            />
            <Route
              exact
              path="/MasterLinkDepartments"
              element={<DepartmentsMasterLink />}
            />
            <Route
              exact
              path="/catalogDepartments"
              element={<DepartmentsMasterLink />}
            />
            <Route exact path="/myProducts" element={<Allproducts />} />
            <Route exact path="/sharedProduct" element={<SharedProduct />} />
            <Route exact path="/allProducts" element={<AllProduct />} />
            <Route exact path="/addProducts" element={<AddProducts />} />
            <Route exact path="/editProducts" element={<AddProducts />} />
            <Route exact path="/appointment" element={<Appointment />} />
            <Route
              exact
              path="/loginPreferences"
              element={<LoginPreferences />}
            />
            <Route
              exact
              path="/transferZZGemfind"
              element={<TransferZZGemfind />}
            />
            <Route exact path="/tradeShows" element={<TradeShows />} />
            <Route exact path="/mailingLists" element={<MailingLists />} />
            <Route exact path="/campaignData" element={<CampaignData />} />
            <Route exact path="/composeMail" element={<ComposeMail />} />
            <Route exact path="/addCampaign" element={<AddCampaignPage />} />
            <Route exact path="/apiAccessToken" element={<ApiAccessToken />} />
            <Route exact path="/addcolor" element={<Addcolor />} />
            <Route exact path="/partnerTypes" element={<PartnerTypes />} />
            <Route exact path="/productDetails" element={<ProductDetails />} />

            <Route
              exact
              path="/applicationPermissions"
              element={<ApplicationPermissions />}
            />
            <Route
              exact
              path="/diamondRapNetPermission"
              element={<DiamondRapNetPermission />}
            />
            <Route
              exact
              path="/addNewRetailerToCore"
              element={<AddNewRetailerToCore />}
            />
            <Route
              exact
              path="/solrCoreIndexer"
              element={<SolrCoreIndexer />}
            />
            <Route exact path="/vendorRatings" element={<VendorRatings />} />
            <Route
              exact
              path="/outGoingDataMap"
              element={<OutGoingDataMap />}
            />

            <Route exact path="/outBoundSync" element={<OutBoundSync />} />

            <Route
              exact
              path="/clientDataMapping"
              element={<ClientDataMapping />}
            />

            <Route element={<FeatureGuard feature="marketing" />}>
              <Route
                exact
                path="/marketingUploadFile"
                element={<MarketingUploadFile />}
              />
              <Route
                exact
                path="/marketingUploadVendor"
                element={<MarketingUploadVendor />}
              />

              <Route exact path="/marketing" element={<Marketing />} />
            </Route>

            <Route
              exact
              path="/retailerMarketing"
              element={<RetailerMarketing />}
              // element={<Marketing />}
            />
            <Route exact path="/limit" element={<Limits />} />
            <Route exact path="/legacy" element={<Legacy />} />
            <Route
              exact
              path="/reportPermissions"
              element={<ReportsPermissions />}
            />
            <Route
              exact
              path="/retailerlocator"
              element={<Retailerlocator />}
            />
            <Route
              exact
              path="/blockDesignersForDemo"
              element={<BlockDesignersRetailer />}
            />
            <Route exact path="/lockedUsers" element={<LockedUsers />} />
            <Route exact path="/dataMaps" element={<DataMaps />} />
            <Route exact path="/metalMarket" element={<MetalMarket />} />
            <Route exact path="/uploadHistory" element={<UploadHistory />} />
            <Route exact path="/diamondStuckFile" element={<StuckFile />} />
            <Route
              exact
              path="/jewelryStuckFile"
              element={<StuckFileJewelry />}
            />
            <Route
              exact
              path="/diamonduploadHistory"
              element={<DiamondUploadHistory />}
            />

            <Route
              exact
              path="/uploadProductFile"
              element={<UploadProductFile />}
            />
            <Route
              exact
              path="/addSingleDiamond"
              element={<AddSignleDiamond />}
            />
            <Route exact path="/print" element={<Print />} />
            <Route
              exact
              path="/uploadDiamondFile"
              element={<UploadDiamondFile />}
            />
            <Route
              exact
              path="/DiamondFtpCredentials"
              element={<FTPCredential type="Diamond" />}
            />
            <Route exact path="/FtpCredential" element={<FTPCredential />} />
            <Route exact path="/Ftpcredential" element={<FTPCredential />} />
            <Route
              exact
              path="/JewelryFtpCredentials"
              element={<FTPCredential type="Jewelry" />}
            />
            <Route
              exact
              path="/RBFtpCredentials"
              element={<FTPCredential type="Jewelry" />}
            />
            <Route
              exact
              path="/applicationPreviewDiamondLink"
              element={
                <PartnerAppGuard>
                  <AppPermissionGuard permKey="diamondLink">
                    <ApplicationPreview />
                  </AppPermissionGuard>
                </PartnerAppGuard>
              }
            />
            <Route
              exact
              path="/applicationPreviewGemStoneLink"
              element={
                <PartnerAppGuard>
                  <AppPermissionGuard permKey="gemstoneLink">
                    <ApplicationPreviewGemStone />
                  </AppPermissionGuard>
                </PartnerAppGuard>
              }
            />
            <Route
              exact
              path="/applicationPreviewRingBuilder"
              element={
                <PartnerAppGuard>
                  <ApplicationPreviewRing />
                </PartnerAppGuard>
              }
            />

            <Route
              exact
              path="/applicationPreviewPedantBuilder"
              element={
                <PartnerAppGuard>
                  <ApplicationPreviewPedant />
                </PartnerAppGuard>
              }
            />
            <Route
              exact
              path="/applicationPreviewStudBuilder"
              element={
                <PartnerAppGuard>
                  <ApplicationPreviewStud />
                </PartnerAppGuard>
              }
            />
            <Route exact path="/manageVendor" element={<Dealers />} />
            <Route
              exact
              path="/minedDiamondMarkup"
              element={<MinedDiamondsMarkup />}
            />
            <Route
              exact
              path="/fancyColorMarkup"
              element={<FancyColorMarkup />}
            />
            <Route exact path="/labGrowMarkup" element={<LabGrowMarkup />} />
            <Route
              exact
              path="/availableFilterSettings"
              element={<AvailableFilterSettings />}
            />
            <Route
              exact
              path="/initialFilterSettings"
              element={<InitialFilterSettings />}
            />
            <Route exact path="/options" element={<Options />} />
            <Route exact path="/shipping" element={<Shipping />} />
            <Route exact path="/navigation" element={<Navigation />} />
            <Route
              exact
              path="/diamondLinkLegacy"
              element={<DiamondLinkLegacy />}
            />
            <Route
              exact
              path="/diamondLinksEmailTemplate"
              element={<DiamondLinksEmailTemplate />}
            />

            <Route
              exact
              path="/diamondLinkApiEndPoint"
              element={<DiamondLinkApiEndPoint />}
            />
            <Route exact path="/viewInquiry" element={<ViewInquiry />} />
            <Route
              exact
              path="/shoppingIntegrations"
              element={<ShoppingIntegrations />}
            />
            <Route exact path="/diamondMapping" element={<DiamondMapping />} />
            <Route
              exact
              path="/editViewDataMapping"
              element={<EditViewDataMapping />}
            />
            <Route
              exact
              path="/diamondGroupDiscount"
              element={<DiamondGroupDiscount />}
            />
            <Route exact path="/retailerGroup" element={<RetailerGroup />} />
            <Route
              exact
              path="/manageCollection"
              element={<ManageCollection />}
            />
            <Route exact path="/metalMarket" element={<MetalMarket />} />
            <Route exact path="/permissions" element={<Permissions />} />
            <Route exact path="/emailTemplate" element={<EmailTemplate />} />
            <Route
              exact
              path="/openSourceMapping"
              element={<MagentoMapping />}
            />
            <Route exact path="/pendingSync" element={<PendingSync />} />
            <Route exact path="/consoleUpload" element={<ConsoleUpload />} />
            <Route exact path="/HasValidImage" element={<HasValidImage />} />
            <Route exact path="/vendorRating" element={<VendorRatings />} />
            <Route exact path="/jewelryMarkup" element={<ProductMarkup />} />
            <Route exact path="/addCollection" element={<AddCollection />} />
            <Route exact path="/editCollection" element={<AddCollection />} />

            <Route
              exact
              path="/viewMyMinedDiamond"
              element={<ViewMyMinedDiamond />}
            />
            <Route
              exact
              path="/viewMyColorDiamond"
              element={<ViewMyColorDiamond />}
            />
            <Route
              exact
              path="/viewMyLabDiamond"
              element={<ViewMyLabDiamond />}
            />
            <Route exact path="/jewelrySearch" element={<JewelrySearch />} />
            <Route exact path="/watchesSearch" element={<WatchesSearch />} />
            <Route exact path="/diamondSearch" element={<DiamondSearch />} />
            <Route exact path="/gemstoneSearch" element={<ColorStoneSearch />} />
            <Route exact path="/viewMyGemstone" element={<ViewMyColorStone />} />
            <Route exact path="/uploadGemstoneFile" element={<UploadColorStoneFile />} />
            <Route exact path="/GemstoneUploadHistory" element={<ColorStoneUploadHistory />} />
            <Route exact path="/addSingleGemstone" element={<AddSingleColorStone />} />
            <Route exact path="/GemstoneMapping" element={<ColorStoneMapping />} />
            <Route exact path="/GemstoneFtpCredentials" element={<ColorStoneFtpCredentials />} />
            <Route exact path="/gemStoneMarkup" element={<GemStoneMarkup />} />
            <Route exact path="/gemStoneOptions" element={<GemStoneOptions />} />
            <Route exact path="/managegemStoneVendor" element={<ManageGemStoneVendor />} />
            <Route
              exact
              path="/gemStoneLinksEmailTemplate"
              element={<GemStoneLinksEmailTemplate />}
            />
            <Route
              exact
              path="/colorDiamondSearch"
              element={<ColorDiamondSearch />}
            />
            <Route
              exact
              path="/labDiamondSearch"
              element={<LabDiamondSearch />}
            />
            <Route
              exact
              path="/colorDiamondSearch"
              element={<ColorDiamondSearch />}
            />
            <Route
              exact
              path="/labDiamondSearch"
              element={<LabDiamondSearch />}
            />
            <Route
              exact
              path="/ringBuilderSettingsMarkups"
              element={<Markups />}
            />
            <Route exact path="/ringBuilderSettings" element={<Settings />} />
            <Route
              exact
              path="/NetworkVendorRingBuilder"
              element={<Vendors />}
            />
            <Route
              exact
              path="/vendorStudBuilder"
              element={<MyNetworkStudBuilder />}
            />
            <Route
              exact
              path="/vendorPendantBuilder"
              element={<MyNetworkPendantBuilder />}
            />
            <Route
              exact
              path="/studBuildermanageVendors"
              element={<StudBuilderManageVendors />}
            />
            <Route
              exact
              path="/studBuilderSettingsMarkup"
              element={<StudBuilderMarkup />}
            />
            <Route
              exact
              path="/studBuilderDiamondVendors"
              element={<StudBuilderDealers />}
            />
            <Route
              exact
              path="/studBuilderDaimondMarkup"
              element={<MinedDiamondMarkup />}
            />
            <Route
              exact
              path="/StudbuilderLabGrowMarkup"
              element={<LabGrowMarkup />}
            />

            <Route
              exact
              path="/pendantBuilderManageVendors"
              element={<PendantBuilderManageVendors />}
            />
            <Route
              exact
              path="/pendantBuilderSettingMarkup"
              element={<PendantBuilderSettingMarkup />}
            />
            <Route
              exact
              path="/pendantBuilderDiamondMarkup"
              element={<MinedDiamondMarkup />}
            />
            <Route
              exact
              path="/PendantBuilderLabGrowMarkup"
              element={<LabGrowMarkup />}
            />

            <Route exact path="/syncHistory" element={<SyncHistory />} />
            <Route exact path="/syncLimiter" element={<SyncLimiter />} />
            <Route
              exact
              path="/outBoundMapping"
              element={<OutBoundMapping />}
            />
            <Route exact path="/ftpDetails" element={<FtpDetails />} />

            <Route exact path="/archiveVendors" element={<ArchiveVendors />} />
            <Route
              exact
              path="/diamondVendorsRingBuilder"
              element={<DiamondVendors />}
            />

            <Route
              exact
              path="/ringBuilderDaimondMarkup"
              element={<MinedDiamondMarkup />}
            />
            <Route
              exact
              path="/ringBuilderLabGrowMarkup"
              element={<LabGrowMarkup />}
            />
            <Route
              exact
              path="/ringBuilderApiEndPoint"
              element={<RingBuilderApiEndPoint />}
            />
            <Route
              exact
              path="/ringbuilderNavigation"
              element={<RingbuilderNavigation />}
            />
            <Route
              exact
              path="/ringbuilderLegacy"
              element={<RingbuilderLegacy />}
            />
            <Route
              exact
              path="/ringbuilderShoppingIntegrations"
              element={<RingbuilderShoppingIntegrations />}
            />
            <Route
              exact
              path="/ringBuilderEmailTemplate"
              element={<RingBuilderEmailTemplate />}
            />

            <Route
              exact
              path="/ringBuilderDealers"
              element={<RingBuilderDealers />}
            />

            <Route
              exact
              path="/ringBuilderOptions"
              element={<RingBuilderOptions />}
            />
            <Route
              exact
              path="/masterlinkLegacy"
              element={<MasterLinkLegacy />}
            />
            <Route
              exact
              path="/studBuilderApplicationPreview"
              element={<StudBuilderApplicationPreview />}
            />

            <Route
              exact
              path="/studBuilderShoppingConfiguration"
              element={<StudBuilderShoppingIntegrations />}
            />

            <Route
              exact
              path="/studBuilderOptions"
              element={<StudBuilderOptions />}
            />

            <Route
              exact
              path="/studBuilderSettings"
              element={<StudBuilderSettings />}
            />

            <Route
              exact
              path="/studBuilderEmailTemplate"
              element={<StudBuilderEmailTemplate />}
            />

            <Route
              exact
              path="/watchCustomizerOptions"
              element={<WatchCustomizerOptions />}
            />

            <Route
              exact
              path="/applicationPreviewWatchCustomizer"
              element={<WatchCustomizer />}
            />

            <Route exact path="/conversation" element={<Conversation />} />

            <Route exact path="/contact" element={<Contact />} />

            <Route exact path="/customer" element={<Customer />} />
            <Route exact path="/profileNew" element={<ProfileNew />} />

            <Route exact path="/appointments" element={<Appointments />} />

            <Route
              exact
              path="/masterlinkOptions"
              element={<MasterLinkOptions />}
            />

            <Route
              exact
              path="/masterlinkShipping"
              element={<MasterLinkShipping />}
            />
            <Route
              exact
              path="/masterlinkEmailTemplate"
              element={<MasterLinkEmailTemplate />}
            />
            <Route
              exact
              path="/masterlinkShoppingConfiguration"
              element={<MasterLinkShoppingIntegration />}
            />
            <Route
              exact
              path="/pendantBuilderApplicationPreview"
              element={<PendantBuilderApplicationPreview />}
            />
            <Route
              exact
              path="/pendantBuilderOptions"
              element={<PendantBuilderOptions />}
            />

            <Route
              exact
              path="/pendantBuilderSettings"
              element={<PendantBuilderSettings />}
            />

            <Route
              exact
              path="/pendantBuilderEmailTemplate"
              element={<PendantBuilderEmailTemplate />}
            />

            <Route
              exact
              path="/pendantBuilderShoppingConfiguration"
              element={<PendantBuilderShoppingIntegrations />}
            />
            <Route
              exact
              path="/pendantBuilderNavigation"
              element={<PendantBuilderNavigation />}
            />

            <Route
              exact
              path="/studBuilderNavigation"
              element={<StudBuilderNavigation />}
            />
            <Route
              exact
              path="/pedantBuilderDiamondVendors"
              element={<PedantBuilderDealers />}
            />
            <Route exact path="/outOfNetwork" element={<OutOfNetwork />} />
            <Route exact path="/new" element={<New />} />
            <Route exact path="/timepieces" element={<Timepieces />} />
            <Route exact path="/allapps" element={<AllApps />} />
            <Route exact path="/myvendors" element={<MyVendors />} />
            <Route exact path="/network" element={<Network />} />
            <Route
              exact
              path="/inviteyourvendor"
              element={<Inviteyourvendor />}
            />
            <Route
              exact
              path="/inviteYourRetailer"
              element={<InviteYourRetailer />}
            />
            <Route exact path="/suggestFeature" element={<SuggestFeature />} />
            <Route
              exact
              path="/recentlyUpdated"
              element={<RecentlyUpdated />}
            />
            <Route
              exact
              path="/vendorManagerPopular"
              element={<VendorManagerPopular />}
            />
            <Route
              exact
              path="/vendorManagerArchived"
              element={<VendorManagerArchived />}
            />
            <Route
              exact
              path="/retailerProfile"
              element={<RetailerProfile />}
            />
            <Route
              exact
              path="/retailerProfileNew"
              element={<RetailerProfileNew />}
            />
            <Route
              exact
              path="/jewelryRetailerPermission"
              element={<JewelryRetailerPermission />}
            />
            <Route
              exact
              path="/inviteARetailer"
              element={<InviteARetailer />}
            />
            <Route
              exact
              path="/makeAppoitments"
              element={<MakeAppoitments />}
            />
            <Route
              exact
              path="/pendingJewelryRequest"
              element={<PendingJewelryRequest />}
            />
            <Route
              exact
              path="/diamondRetailerPermission"
              element={<DiamondRetailerPermission />}
            />
            <Route
              exact
              path="/pendingDiamondRequest"
              element={<PendingDiamondRequest />}
            />
            <Route
              exact
              path="/gemstoneRetailerPermission"
              element={<GemstoneRetailerPermission />}
            />
            <Route
              exact
              path="/ringBuilderRetailerPermission"
              element={<RingBuilderRetailerPermission />}
            />
            <Route
              exact
              path="/pendingRingBuilderRequest"
              element={<PendingRingBuilderRequest />}
            />
            <Route
              exact
              path="/vendorManagerPendingRequests"
              element={<VendorManagerPendingRequests />}
            />

            <Route exact path="/vendorProfile" element={<VendorProfile />} />
            <Route
              exact
              path="/appsVendorProfile"
              element={<VendorProfile />}
            />
            <Route
              exact
              path="/manageInventory"
              element={<ManageInventory />}
            />
            <Route exact path="/viewInventory" element={<ViewInventory />} />
            <Route exact path="/dealerProfile" element={<DealerProfile />} />
            <Route element={<FeatureGuard feature="reports" />}>
              <Route
                exact
                path="/JewelryMetalTypeReportMain"
                element={<JewelryMetalTypeReportMain />}
              />
              <Route
                exact
                path="/diamondAddToCartReport"
                element={<AddToCartReports />}
              />

              <Route
                exact
                path="/gemstoneAddToCartReport"
                element={<AddToCartReports />}
              />

              <Route
                exact
                path="/jewelryVendorAddToCartReport"
                element={<VendorActivityReport key="jewelry-addtocart" productType="Jewelry" addToType="AddToCart" title="Jewelry Add to Cart Report" />}
              />

              <Route
                exact
                path="/jeweleryPriceBasedAddToCartReports"
                element={<JeweleryPriceBasedAddToCartReports />}
              />
              <Route
                exact
                path="/jeweleryPriceBasedWishListReports"
                element={<JeweleryPriceBasedWishListReports />}
              />

              <Route
                exact
                path="/jeweleryVendorBasedWishListReports"
                element={<VendorActivityReport key="jewelry-wishlist" productType="Jewelry" addToType="AddToWishlist" title="Jewelry Wish List Report" />}
              />

              <Route
                exact
                path="/diamondPriceBasedAddToCartReports"
                element={<DiamondPriceBasedAddToCartReports />}
              />

              <Route
                exact
                path="/diamondVendorBasedAddToCartReports"
                element={<VendorActivityReport key="diamond-addtocart" productType="Diamond" addToType="AddToCart" title="Diamond Add to Cart Report" />}
              />

              <Route
                exact
                path="/diamondVendorBasedWishListReport"
                element={<VendorActivityReport key="diamond-wishlist" productType="Diamond" addToType="AddToWishlist" title="Diamond Wish List Report" />}
              />

              <Route
                exact
                path="/diamondPriceBasedWishListReports"
                element={<DiamondPriceBasedWishListReports />}
              />

              <Route
                exact
                path="/diamondWishListReport"
                element={<WishListReports />}
              />

              <Route element={<ReportPermissionGuard permission="gemstoneCharts" />}>
                <Route
                  exact
                  path="/gemstonePriceBasedAddToCartReports"
                  element={<GemstonePriceBasedAddToCartReports />}
                />

                <Route
                  exact
                  path="/gemstoneVendorBasedAddToCartReports"
                  element={<GemstoneVendorBasedAddToCartReport />}
                />
              </Route>

              <Route
                exact
                path="/gemstoneVendorBasedWishListReport"
                element={<GemstoneVendorBasedWishListReport />}
              />

              <Route
                exact
                path="/gemstonePriceBasedWishListReports"
                element={<GemstonePriceBasedWishListReports />}
              />

              <Route
                exact
                path="/gemstoneWishListReport"
                element={<WishListReports />}
              />
              <Route
                exact
                path="/JewelryPriceReportMain"
                element={<JewelryPriceReportMain />}
              />

              <Route
                exact
                path="/jewelryRetailerClickReportMain"
                element={<JewelryRetailerClickReportMain />}
              />

              <Route
                exact
                path="/JewelryVendorClickReportMain"
                element={<JewelryVendorClickReportMain />}
              />
            </Route>

            <Route
              exact
              path="/jewelryLocationActivity"
              element={<JewelryLocationActivity />}
            />

            <Route element={<FeatureGuard feature="reports" />}>
              <Route
                exact
                path="/globalJewelryChartReports"
                element={<GlobalJewelryChartReports />}
              />

              <Route
                exact
                path="/globalJewelryCategoryReport"
                element={<GlobalJewelryCategoryReport />}
              />

              <Route
                exact
                path="/globalJewelryMetalTypeReport"
                element={<GlobalJewelryMetalTypeReport />}
              />

              <Route
                exact
                path="/globalJewelryPriceReport"
                element={<GlobalJewelryPriceReport />}
              />

              <Route
                exact
                path="/globalJewelryAddToCartReport"
                element={<VendorActivityReport key="global-jewelry-addtocart" productType="Jewelry" addToType="AddToCart" title="Jewelry Add to Cart Report" isGlobal />}
              />

              <Route
                exact
                path="/globalJewerlyWishListReport"
                element={<VendorActivityReport key="global-jewelry-wishlist" productType="Jewelry" addToType="AddToWishlist" title="Jewelry Wish List Report" isGlobal />}
              />

              <Route
                exact
                path="/globalDiamondAddToCartReport"
                element={<VendorActivityReport key="global-diamond-addtocart" productType="Diamond" addToType="AddToCart" title="Diamond Add to Cart Report" isGlobal />}
              />

              <Route
                exact
                path="/globalDiamondWishListReport"
                element={<VendorActivityReport key="global-diamond-wishlist" productType="Diamond" addToType="AddToWishlist" title="Diamond Wish List Report" isGlobal />}
              />

              {/* <Route
                  exact
                  path="/diamondAddToCartReport"
                  element={<DiamondAddToCartReport />}
                /> */}

              {/* <Route
                  exact
                  path="/diamondWishListReport"
                  element={<DiamondWishListReport />}
                /> */}

              <Route
                exact
                path="/globalGemstoneAddToCartReport"
                element={<GlobalGemstoneAddToCartReport />}
              />

              <Route
                exact
                path="/globalGemstoneWishListReport"
                element={<GlobalGemstoneWishListReport />}
              />

              {/* <Route
                  exact
                  path="/gemstoneAddToCartReport"
                  element={<GemstoneAddToCartReport />}
                /> */}

              {/* <Route
                  exact
                  path="/gemstoneWishListReport"
                  element={<GemstoneWishListReport />}
                /> */}

              <Route
                exact
                path="/jewerlyWishListReport"
                element={<JewerlyWishListReport />}
              />
            </Route>

            {/* Purchase Order Starts */}
            <Route element={<FeatureGuard feature="po" />}>
              <Route
                exact
                path="/purchaseOrderHistory"
                element={<PurchaseOrderHistory />}
              />
              <Route
                exact
                path="/updatePurchaseOrder"
                element={<UpdatePurchaseOrder />}
              />
              <Route exact path="/PODashboard" element={<PODashboard />} />
              <Route exact path="/createOrder" element={<VendorOrderBuilder />} />
              <Route exact path="/myOrders" element={<MyOrders />} />
              <Route exact path="/orderReport" element={<OrderReport />} />
              <Route exact path="/organizerDashboard" element={<OrganizerDashboard />} />
              <Route exact path="/deliverySettings" element={<DeliverySettings />} />
              <Route exact path="/inbox" element={<Inbox />} />
              <Route exact path="/orderLog" element={<OrderLog />} />
              <Route exact path="/orderDetail/:poId" element={<OrderDetail />} />

              <Route
                exact
                path="/workSheetDetails"
                element={<WorkSheetDetails />}
              />
              <Route
                exact
                path="/purchaseOrderDetails"
                element={<PurchaseOrderDetails />}
              />
            </Route>
            {/* Purchase Order Ends */}
            <Route element={<FeatureGuard feature="reports" />}>
              {/* Bug 1736: enforce reportPermisstion.jewelryCharts, mirroring sidemenu.js's gray-out logic */}
              <Route element={<ReportPermissionGuard permission="jewelryCharts" />}>
                <Route
                  exact
                  path="/jewelryCategoryReport"
                  element={<JewelryCategoryReport />}
                />

                <Route
                  exact
                  path="/jewelryChartReport"
                  element={<JewelryChartReport />}
                />
              </Route>
            </Route>

            {/* Purchase Order Starts */}
            <Route element={<FeatureGuard feature="po" />}>
              <Route exact path="/purchaseOrder" element={<PurchaseOrder />} />
              <Route exact path="/myPurchaseOrder" element={<PurchaseOrder />} />

              <Route exact path="/worksheet" element={<Worksheet />} />
              <Route exact path="/myWorksheet" element={<Worksheet />} />

              <Route
                exact
                path="/purchaseOrderHistory"
                element={<PurchaseOrderHistory />}
              />
              <Route
                exact
                path="/updatePurchaseOrder"
                element={<UpdatePurchaseOrder />}
              />
              <Route exact path="/addresses" element={<Addresses />} />
              <Route exact path="/basket" element={<Basket />} />
              <Route exact path="/document/:id" element={<DocumentDetail />} />
              <Route exact path="/my-memos" element={<MyMemos />} />
              <Route exact path="/purchase-orders" element={<DiamondPurchaseOrders />} />
              <Route exact path="/requests" element={<SupplierRequests />} />
              <Route exact path="/returns-inbound" element={<ReturnsInbound />} />
              <Route exact path="/diamond-dashboard" element={<SupplierDashboard />} />
              <Route exact path="/diamond-reports" element={<DiamondReports />} />
            </Route>
            {/* Purchase Order Ends */}

            {/* Marketing Starts */}
            <Route element={<FeatureGuard feature="marketing" />}>
              <Route
                exact
                path="/uploadMarketingMaterial"
                element={<UploadMarketingMaterial />}
              />
            </Route>
            {/* Marketing Ends */}
            {/* Note: this third purchaseOrderHistory declaration was originally mislabeled
                inside the "Marketing" comment block above — it's PO, guarded as such. */}
            <Route element={<FeatureGuard feature="po" />}>
              <Route
                exact
                path="/purchaseOrderHistory"
                element={<PurchaseOrderHistory />}
              />
            </Route>

            {/* Header Avatar Dropdown Starts */}
            <Route exact path="/companyProfile" element={<CompanyProfile />} />
            <Route exact path="/userSettings" element={<UserSettings />} />
            <Route
              exact
              path="/socialIntegrations"
              element={<SocialIntegrations />}
            />
            <Route
              exact
              path="/companyLocation"
              element={<CompanyLocation />}
            />
            <Route exact path="/userProfile" element={<UserProfile />} />
            <Route exact path="/changePassword" element={<ChangePassword />} />
            <Route exact path="/manageUser" element={<ManageUser />} />
            <Route exact path="/whiteLabel" element={<WhiteLabel />} />
            <Route
              exact
              path="/createOrganization"
              element={<Organization />}
            />

            <Route
              exact
              path="/manageCompanyShows"
              element={<ManageCompanyShows />}
            />
            <Route exact path="/manageBrands" element={<ManageBrands />} />
            <Route exact path="/manageAccount" element={<ManageAccount />} />
            <Route exact path="/manageLanguage" element={<ManageLanguage />} />
            <Route exact path="/manageCurrency" element={<ManageCurrency />} />
            {/* Header Avatar Dropdown Ends */}

            <Route exact path="/DataMaping" element={<DataMaping />} />
            <Route exact path="/brands" element={<Brands />} />
            <Route exact path="/vendors" element={<Vendor />} />
            {/* <Route exact path="/companyEmailSetting" element={<CompanyEmailSetting />} /> */}

            <Route
              exact
              path="/jewelryChartReportAdmin"
              element={<JewelryChartReportAdmin />}
            />
            <Route
              exact
              path="/jewelryCategoryReportAdmin"
              element={<JewelryCategoryReportAdmin />}
            />
            <Route
              exact
              path="/jewelryMetalTypeReport"
              element={<JewelryMetalTypeReport />}
            />
            <Route
              exact
              path="/jewelryPriceReport"
              element={<JewelryPriceReport />}
            />

            {/* #1713 case 6: Admin > Jewelry / Diamond Report - Add to Cart / Wish List (global) */}
            <Route
              exact
              path="/jewelryAddToCartReportAdmin"
              element={<VendorActivityReport key="admin-jewelry-addtocart" productType="Jewelry" addToType="AddToCart" title="Jewelry Add to Cart Report" isGlobal />}
            />
            <Route
              exact
              path="/jewelryWishListReportAdmin"
              element={<VendorActivityReport key="admin-jewelry-wishlist" productType="Jewelry" addToType="AddToWishlist" title="Jewelry Wish List Report" isGlobal />}
            />
            <Route
              exact
              path="/diamondAddToCartReportAdmin"
              element={<VendorActivityReport key="admin-diamond-addtocart" productType="Diamond" addToType="AddToCart" title="Diamond Add to Cart Report" isGlobal />}
            />
            <Route
              exact
              path="/diamondWishListReportAdmin"
              element={<VendorActivityReport key="admin-diamond-wishlist" productType="Diamond" addToType="AddToWishlist" title="Diamond Wish List Report" isGlobal />}
            />

            <Route
              exact
              path="/jewelryRetailerClicksReport"
              element={<JewelryRetailerClicksReport />}
            />

            <Route
              exact
              path="/jewelryVendorClicksReport"
              element={<JewelryVendorClicksReport />}
            />

            <Route exact path="/globalEvents" element={<GlobalEvents />} />

            <Route exact path="/sync" element={<Syncs />} />

            <Route exact path="/toolsreports" element={<ToolsReports />} />

            <Route exact path="/clientsReports" element={<ClientsReports />} />

            <Route exact path="/dataRelated" element={<DataRelated />} />

            <Route
              exact
              path="/jewelryLogReports"
              element={<JewelryLogReports />}
            />

            <Route exact path="/diamondClicks" element={<DiamondClicks />} />

            <Route element={<FeatureGuard feature="reports" />}>
              <Route
                exact
                path="/extendedDiamondChartReports"
                element={<ExtendedDiamondChartReports />}
              />

              <Route
                exact
                path="/diamondClarityReport"
                element={<DiamondClarityReport />}
              />

              <Route exact path="/diamondColor" element={<DiamondColor />} />

              <Route
                exact
                path="/diamondCutReport"
                element={<DiamondCutReport />}
              />

              <Route
                exact
                path="/diamondShapeReport"
                element={<DiamondShapeReport />}
              />

              <Route
                exact
                path="/diamondCertificateReport"
                element={<DiamondCertificateReport />}
              />

              <Route
                exact
                path="/diamondSizeReport"
                element={<DiamondSizeReport />}
              />

              <Route
                exact
                path="/diamondChartReportsMain"
                element={<DiamondReportsChartsIndComp />}
              />

              <Route
                exact
                path="/extendedDiamondChartReportsMain"
                element={<ExtendedDiamondChartReportsMain />}
              />

              <Route
                exact
                path="/diamondClarityReportMain"
                element={<DiamondReportsClarityIndComp />}
              />

              <Route
                exact
                path="/diamondColorMain"
                element={<DiamondReportsColorIndComp />}
              />

              <Route
                exact
                path="/diamondCutGradeReportMain"
                element={<DiamondReportsCutIndComp />}
              />

              <Route
                exact
                path="/diamondCertificateReportMain"
                element={<DiamondReportsCertificateIndComp />}
              />

              <Route
                exact
                path="/diamondShapeReportMain"
                element={<DiamondReportsShapeIndComp />}
              />

              <Route
                exact
                path="/diamondSizeReportMain"
                element={<DiamondReportsSizeIndComp />}
              />
            </Route>

            <Route
              exact
              path="/diamondClicksReportMain"
              element={<DiamondReportsClicksIndComp />}
            />

            <Route
              exact
              path="/locationActivity"
              element={<LocationActivity />}
            />

            <Route element={<FeatureGuard feature="reports" />}>
              <Route
                exact
                path="/globalExtendedDiamondChartReports"
                element={<GlobalExtendedDiamondChartReports />}
              />

              <Route
                exact
                path="/globalDiamondClarityReport"
                element={<DiamondClarityIndComp />}
              />

              <Route
                exact
                path="/globalDiamondColorReport"
                element={<DiamondColorIndComp />}
              />

              <Route
                exact
                path="/globalDiamondCutReport"
                element={<DiamondCutIndComp />}
              />

              <Route
                exact
                path="/globalDiamondShapeReport"
                element={<DiamondShapeIndComp />}
              />

              <Route
                exact
                path="/globalDiamondCertificateReport"
                element={<DiamondCertificateIndComp />}
              />

              <Route
                exact
                path="/globalDiamondSizeReport"
                element={<DiamondSizeIndComp />}
              />
            </Route>

            <Route exact path="/gemstoneClicks" element={<GemstoneClicks />} />

            <Route element={<FeatureGuard feature="reports" />}>
              <Route
                exact
                path="/extendedGemstoneChartReports"
                element={<ExtendedGemstoneChartReports />}
              />

              <Route
                exact
                path="/gemstoneClarityReport"
                element={<GemstoneClarityReport />}
              />

              <Route
                exact
                path="/gemstoneGemTypeReport"
                element={<GemstoneGemTypeReport />}
              />

              <Route exact path="/gemstoneColor" element={<GemstoneColor />} />

              <Route
                exact
                path="/gemstoneCutReport"
                element={<GemstoneCutReport />}
              />

              <Route
                exact
                path="/gemstoneShapeReport"
                element={<GemstoneShapeReport />}
              />

              <Route
                exact
                path="/gemstoneCertificateReport"
                element={<GemstoneCertificateReport />}
              />

              <Route
                exact
                path="/gemstoneSizeReport"
                element={<GemstoneSizeReport />}
              />

              <Route element={<ReportPermissionGuard permission="gemstoneCharts" />}>
                <Route
                  exact
                  path="/gemstoneChartReportsMain"
                  element={<GemstoneReportsChartsIndComp />}
                />

                <Route
                  exact
                  path="/extendedGemstoneChartReportsMain"
                  element={<ExtendedGemstoneChartReportsMain />}
                />

                <Route
                  exact
                  path="/gemstoneClarityReportMain"
                  element={<GemstoneReportsClarityIndComp />}
                />

                <Route
                  exact
                  path="/gemstoneGemTypeReportMain"
                  element={<GemstoneReportsGemTypeIndComp />}
                />

                <Route
                  exact
                  path="/gemstoneColorMain"
                  element={<GemstoneReportsColorIndComp />}
                />

                <Route
                  exact
                  path="/gemstoneCutGradeReportMain"
                  element={<GemstoneReportsCutIndComp />}
                />

                <Route
                  exact
                  path="/gemstoneCertificateReportMain"
                  element={<GemstoneReportsCertificateIndComp />}
                />

                <Route
                  exact
                  path="/gemstoneShapeReportMain"
                  element={<GemstoneReportsShapeIndComp />}
                />

                <Route
                  exact
                  path="/gemstoneSizeReportMain"
                  element={<GemstoneReportsSizeIndComp />}
                />
              </Route>
            </Route>

            <Route element={<ReportPermissionGuard permission="gemstoneCharts" />}>
              <Route
                exact
                path="/gemstoneClicksReportMain"
                element={<GemstoneReportsClicksIndComp />}
              />
            </Route>

            <Route
              exact
              path="/gemstoneLocationActivity"
              element={<GemstoneLocationActivity />}
            />

            <Route element={<FeatureGuard feature="reports" />}>
              {/* Bug 2038: enforce reportPermisstion.globalGemstoneCharts, mirroring the Bug 1736 fix for jewelryCharts */}
              <Route element={<ReportPermissionGuard permission="globalGemstoneCharts" />}>
                <Route
                  exact
                  path="/globalExtendedGemstoneChartReports"
                  element={<GlobalExtendedGemstoneChartReports />}
                />

                <Route
                  exact
                  path="/globalGemstoneChartReport"
                  element={<GemstoneChartsIndComp />}
                />

                <Route
                  exact
                  path="/globalGemstoneClarityReport"
                  element={<GemstoneClarityIndComp />}
                />

                <Route
                  exact
                  path="/globalGemstoneGemTypeReport"
                  element={<GemstoneGemTypeIndComp />}
                />

                <Route
                  exact
                  path="/globalGemstoneColorReport"
                  element={<GemstoneColorIndComp />}
                />

                <Route
                  exact
                  path="/globalGemstoneCutReport"
                  element={<GemstoneCutIndComp />}
                />

                <Route
                  exact
                  path="/globalGemstoneShapeReport"
                  element={<GemstoneShapeIndComp />}
                />

                <Route
                  exact
                  path="/globalGemstoneCertificateReport"
                  element={<GemstoneCertificateIndComp />}
                />

                <Route
                  exact
                  path="/globalGemstoneSizeReport"
                  element={<GemstoneSizeIndComp />}
                />
              </Route>
            </Route>

            <Route exact path="/adminDataMapping" element={<DataMaping />} />

            <Route
              exact
              path="/inboundDataMapping"
              element={<InboundClientDataMaping />}
            />
            <Route
              exact
              path="/uploadClientDataMapping"
              element={<UploadAdminProductFile />}
            />
            <Route
              exact
              path="/myVendorsRingBuilder"
              element={<MyVendorsRingBuilder />}
            />
            <Route
              exact
              path="/myVendorsStudBuilder"
              element={<MyVendorsStudBuilder />}
            />
            <Route
              exact
              path="/pendantBuilderPendingVendorRequest"
              element={<PendantBuilderPendingVendorRequest />}
            />
            <Route
              exact
              path="/myVendorsPendantBuilder"
              element={<MyVendorsPendantBuilder />}
            />
            <Route
              exact
              path="/pendingVendorRequestRingBuilder"
              element={<RingBuilderPendingVendorRequest />}
            />
            <Route
              exact
              path="/pendingVendorRequestStudBuilder"
              element={<StudBuilderPendingVendorRequest />}
            />
            <Route exact path="/vendorRequest" element={<VendorRequest />} />
            <Route exact path="/vendorRequests" element={<VendorRequest />} />
            <Route exact path="/pricingGeneral" element={<PricingGeneral />} />
            <Route exact path="/scaMaster" element={<SCAMaster />} />
          </Route>
        </Routes>
        <NotificationContainer />
      </React.Fragment>
    </BrowserRouter>
  );
};

export default App;
